// 管理接口
import {
    get,
    post,
    json
} from './http'


//登录
export const login = data => json('sys/dealerLogin', data);

export const newlogin = data => json('sys/dealerNewLogin', data);


//获取经销商类型
export const dictList = data => post('sys/dict/dealerList', data);
//注册
export const dealer = data => json('business/dealer/save', data);
//注册信息
export const dealerFindOne = data => post('business/dealer/findOne', data);
//注册 修改
export const dealerUpdate = data => json('business/dealer/update', data);
//修改密码
export const userpassword = data => post('sys/user/password', data);
//新增下单开单
export const purchaseOrderBusinessControllerAdd = data => json('business/purchaseOrderBusinessController/add', data);
//工厂
export const managerList = data => post('business/pushInfoBusinessController/selectDealerManager', data);
//产品
export const actProductBusinessController = data => post('business/actProductBusinessController/selectProduct', data);
//查询下单开单
export const purchaseOrderBusinessControllerSelect = data => post('business/purchaseOrderBusinessController/select', data);
//删除下单开单
export const purchaseOrderBusinessControllerDelete = data => post('business/purchaseOrderBusinessController/delete', data);
//撤销下单开单
export const purchaseOrderBusinessControllersetState = data => post('business/purchaseOrderBusinessController/revocation', data);
//修改下单开单
export const purchaseOrderBusinessControllersetupdate = data => json('business/purchaseOrderBusinessController/update', data);
//确认收款
export const purchaseOrderBusinessControllersetStatePay = data => post('business/purchaseOrderBusinessController/setStatePay', data);

//分配账号
export const dealerAllot = data => json('business/dealer/allot', data);
//分配账号 列表
export const userList = data => post('sys/user/list', data);
//分配账号 修改
export const userupdate = data => json('sys/user/update', data);
//分配账号 删除
export const userdelete = data => post('sys/user/delete', data);
//验证码
export const nodeSend = data => post('sys/node/send', data);


//预警设置
export const dealerUpdateInfo = data => json('business/dealer/updateInfo', data);


//进销存 工厂
export const selcetManagerWarning = data => post('business/actRepertoryBusinessController/selcetManagerWarning', data);
//进销存 产品
export const selectOneManagerWarn = data => post('business/actRepertoryBusinessController/selectOneManagerWarn', data);
//进销存 忽略
export const setIgnore = data => post('business/actRepertoryBusinessController/setIgnore', data);
//添加到下单开单
export const warnAddPurchaseOrder = data => post('business/actRepertoryBusinessController/warnAddPurchaseOrder', data);
//进销存 搜索
export const selcetManagerWarningLike = data => post('business/actRepertoryBusinessController/selcetManagerWarningLike', data);


/*******************************************产品录入**********************************************/
//新增产品分类接口
export const Newproductclassification = data => json('/business/actProductTypeBusinessController/add', data);
//获取产品分类接口
export const Getproductclassification = data => post('/business/actProductTypeBusinessController/pingtaiSelectList', data);
//查询产品列表接口
export const Getproductlist = data => post('/business/actProductBusinessController/selectProduct', data);
//查询产品表头接口
export const Getproductheader = data => post('/business/actProductBusinessController/selectProductType', data);
//查询分类列表接口
export const Getcategorylist = data => post('/business/actProductTypeBusinessController/selectAll', data);
//新增产品接口
export const Newproductentryinterface = data => json('/business/actProductBusinessController/add', data);
//获取产品详情接口
export const Getproductdetails = data => post('/business/actProductBusinessController/details', data);
//获取分类详情接口
export const Getcategorydetails = data => post('/business/actProductTypeBusinessController/details', data);
//删除产品接口
export const delproductdetails = data => post('/business/actProductBusinessController/delete', data);
//删除分类接口
export const delcategorydetails = data => post('/business/actProductTypeBusinessController/delete', data);
//修改产品接口
export const Modifyproductinterface = data => json('/business/actProductBusinessController/update', data);
//修改分类接口
export const Editcategoryinterface = data => json('/business/actProductTypeBusinessController/update', data);
//产品与视频关联接口
export const VideoAssociationinterface = data => post('/business/actProductBusinessController/setVideoUuid', data);
//获取已上传视频列表
export const Getvideouploadlist = data => post('/business/actProductBusinessController/selectVideo', data);
//产品录入文件上传接口
export const associationimportExcel = data => post('/business/importFileController/importExcel', data);
//产品导入文件接口
export const Productimport = data => post('/business/importFileController/haveTbaleImportExcel', data);
//分类导入文件接口
export const Classifiedimport = data => post('/business/importFileController/importExcel', data);

/*******************************************产品录入**********************************************/



//经销商 列表
export const dealerList = data => post('business/dealer/list', data)
//经销商 详情
export const dealerFindone = data => post('business/dealer/findOne', data)
//经销商 审核
export const dealerCheck = data => json('business/dealer/check', data)
//获取全部基础数据接口
export const getBasicdatamanagement = data => post('/sys/dict/list', data)
//信息发布  新增
export const pushInfoBusinessControllerAdd = data => json('business/pushInfoBusinessController/addPushInfo', data)
//信息发布  列表
export const pushInfoBusinessControllerSelect = data => post('business/pushInfoBusinessController/pcSelect', data)
//信息发布  详情
export const selectPushInfoDetail = data => post('business/pushInfoBusinessController/selectPushInfoDetail', data)
//信息发布  删除
export const selectPushInfoDelete = data => post('business/pushInfoBusinessController/delete', data)
//信息发布  修改
export const selectPushInfoUpdate = data => json('business/pushInfoBusinessController/update', data)
//信息发布  工厂列表
export const selectJoinFactory = data => post('business/pushInfoBusinessController/selectJoinFactory', data)
//信息发布  人员列表
export const getFactorySysUser = data => post('business/pushInfoBusinessController/getFactorySysUser', data)

//品牌
export const getCarBrandList = data => post('business/pushInfoBusinessController/getCarBrandList', data)
//车系
export const getCarSeriesList = data => post('business/pushInfoBusinessController/getCarSeriesList', data)
//车型
export const getCarModelList = data => post('business/pushInfoBusinessController/getCarModelList', data)
//获取城市
export const cityList = data => post('sys/city/list', data);


//提成统计
export const selectDealerManagerList = data => post('business/yxRoyaltyBusinessController/selectDealerManagerList', data);
//列表
export const selectDealerManagerDetail = data => post('business/yxRoyaltyBusinessController/selectDealerManagerDetail', data);
//收益
export const selectDealerData = data => post('business/yxRoyaltyBusinessController/selectDealerData', data);
//搜索
export const selectDealerManagerLike = data => post('business/yxRoyaltyBusinessController/selectDealerManagerLike', data);


//客户信息 列表
export const selectClient = data => post('business/yxRoadBusinessController/pcSelectClient', data);
//合作客户列表
export const managerdealerlist = data => post('business/managerdealer/list', data);

//客户信息 新增
export const addRoadClient = data => json('business/yxRoadBusinessController/addRoadClient', data);
//客户信息 详情
export const selectOneClient = data => post('business/yxRoadBusinessController/selectOneClient', data);
//客户信息 修改
export const updateRoadClient = data => json('business/yxRoadBusinessController/updateRoadClient', data);
//客户信息 删除
export const deleteRoad = data => post('business/yxRoadBusinessController/delete', data);

//拜访路线
export const pcSelectTotal = data => post('business/yxRoadBusinessController/pcSelectTotal', data);
export const selectPcRoadByUserUuid = data => post('business/yxRoadBusinessController/selectPcRoadByUserUuid', data);
export const selectReport = data => post('business/yxRoadBusinessController/selectReport', data);
export const selectUser = data => post('business/yxRoadBusinessController/selectUser', data);
export const selectRoadManager = data => post('business/yxRoadBusinessController/selectRoadManager', data);
export const dictListTotal = data => post('sys/dict/list', data);

export const bindingInfo = data => post('business/manager/bindingInfo', data);


//分配客户
export const selectAllocationClient = data => post('business/yxRoadBusinessController/selectAllocationClient', data);
//分配确认
export const ApplicationClient = data => json('business/yxRoadBusinessController/ApplicationClient', data);

//业务人员路线 详情
export const selectUserRoadDetail = data => post('business/yxRoadBusinessController/selectUserRoadDetail', data);

//新增文件
export const addFile = data => json('business/yxFileManagerBusinessController/addFile', data);
//文件管理 查询
export const selectFile = data => post('business/yxFileManagerBusinessController/selectFile', data);
//文件管理 删除
export const deleteFile = data => post('business/yxFileManagerBusinessController/deleteFile', data);
//文件管理 详情
export const fileDetails = data => post('business/yxFileManagerBusinessController/fileDetails', data);


//新增文件夹
export const addFolder = data => post('business/yxFileManagerBusinessController/addFolder', data);
//新增文件夹 查询
export const selectFolder = data => post('business/yxFileManagerBusinessController/selectFolder', data);
//文件夹管理 删除
export const deleteFolder = data => post('business/yxFileManagerBusinessController/deleteFolder', data);

//合并路线
export const mergeRoad = data => json('business/yxRoadBusinessController/mergeRoad', data);
//路线管理
export const pcRoadManager = data => post('business/yxRoadBusinessController/pcRoadManager', data);
//删除
export const deleteRoads = data => post('business/yxRoadBusinessController/deleteRodeClient', data);
//置顶
export const stick = data => post('business/yxRoadBusinessController/stick', data);
export const stickup = data => post('/business/yxRoadBusinessController/up', data);
export const stickdown = data => post('/business/yxRoadBusinessController/down', data);


//充值
export const dealerprizesave = data => json('/business/dealerprize/save', data);
//列表
export const dealerprizelist = data => post('/business/dealerprize/list', data);

//所有业务人员
export const selectUserList = data => post('/business/yxRoadBusinessController/selectUserList', data);
//客户 历史拜访
export const selectClientRecord = data => post('/business/yxRoadBusinessController/selectClientRecord', data);


//智能人事——新增请假类型
export const addApplicationType = data => post('/business/checkWorkerController/addApplicationType', data);
//新增请假类型 查询
export const selectApplicationType = data => post('/business/checkWorkerController/selectApplicationType', data);
//请假类型管理 删除
export const deleteApplicationType = data => post('/business/checkWorkerController/deleteApplicationType', data);

// 智能人事——审批列表
export const selectAll = data => post('/business/checkWorkerController/selectAll', data);
// 审批详情
export const selectDetail = data => post('/business/checkWorkerController/selectDetail', data);
// 审批通过
export const approvePass = data => post('/business/checkWorkerController/pass', data);
// 审批驳回
export const approveReject = data => post('/business/checkWorkerController/reject', data);

//获取预警列表
export const findWarning = data => post('business/dealer/findWarning', data);

export const getservicecharge = data => post('business/dealerCost/getState', data);
//获取三级列表
export const getuserservicecharge = data => post('business/dealerCost/getservicecharge', data);

//根据分类查询品牌
export const getselectBrand = data => post('business/actProductBusinessController/selectBrand', data);
//查询经销商详情
export const getselectContent = data => post('business/dealer/selectContent', data);
//添加经销商详情
export const addcontent = data => post('business/dealer/saveContent', data);


//协议列表
export const yxagreementlist = data => post('frame/yxagreement/list', data);
//协议新增
export const yxagreementsave = data => json('frame/yxagreement/save', data);
//协议详情
export const yxagreementinfo = data => post('frame/yxagreement/info/' +data, data);
//协议删除
export const yxagreementdelete = data => post('frame/yxagreement/delete', data);
//协议修改
export const yxagreementupdate = data => json('frame/yxagreement/update', data);
//根据经销商查业务员列表
export const getywylist = data => post('sys/user/list ', data);

//产品大类新增
export const addactProductTypeBusinessController = data => json('business/actProductTypeBusinessController/addParent', data);
//产品大类列表
export const actProductTypeBusinessControllerlist = data => post('business/actProductTypeBusinessController/selectParent', data);

//导出活动
export const userexportManager = data => post('business/pushInfoBusinessController/exportManager', data);

//设置商品积分
export const productIntegral = data => post('business/actProductTypeBusinessController/setIntegral',data);
